import { styled } from '@mui/material'
import { TTheme } from '@/core/theme'

export const Button = styled('button')<{
    theme?: TTheme
    isOpen?: boolean
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.semantic.backgroundSecondary};
    border: none;
    cursor: pointer;
    &:hover {
        background: ${({ theme }) => theme.colors.greys[100]};
    }
    background: ${({ isOpen, theme }) =>
        isOpen
            ? theme.colors.greys[100]
            : theme.colors.semantic.backgroundSecondary};
`

export const Dots = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
`

export const Dot = styled('span')<{
    theme?: TTheme
}>`
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary['400']};
    display: block;
`
